<template>
  <div class="header-height">
    <div class="header-fixed">
      <div class="header">
        <router-link to="/"
          ><img class="logo" src="../assets/images/logo.png"
        /></router-link>
        <el-menu
          :default-active="$route.path"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="/">
            <router-link to="/"
              ><i>{{ getTitle('header.home') }}</i></router-link
            >
          </el-menu-item>
          <el-submenu index="/overview">
            <template slot="title">
              <i>{{ getTitle('header.overview') }}</i>
            </template>
            <el-menu-item index="/overview/introduction">
              <router-link to="/overview/introduction"
                ><i>{{ getTitle('header.introduction') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/overview/scenic-spots">
              <router-link to="/overview/scenic-spots"
                ><i>{{ getTitle('header.scenicSpots') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/overview/base-info">
              <router-link to="/overview/base-info"
                ><i>{{ getTitle('header.baseInfo') }}</i></router-link
              >
            </el-menu-item>
          </el-submenu>
          <el-submenu index="/strategy">
            <template slot="title"
              ><i>{{ getTitle('header.strategy') }}</i></template
            >
            <el-menu-item index="/strategy/traffic">
              <router-link to="/strategy/traffic"
                ><i>{{ getTitle('header.traffic') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/strategy/route">
              <router-link to="/strategy/route"
                ><i>{{ getTitle('header.touristRoutes') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/strategy/photo">
              <router-link to="/strategy/photo"
                ><i>{{ getTitle('header.photo') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/strategy/note">
              <router-link to="/strategy/note"
                ><i>{{ getTitle('header.travelNotes') }}</i></router-link
              >
            </el-menu-item>
          </el-submenu>
          <el-submenu index="">
            <template slot="title"
              ><i>{{ getTitle('header.dynamic') }}</i></template
            >
            <el-menu-item index="/notice">
              <a @click="jumpPage('1')">
                <i>{{ getTitle('header.notice') }}</i>
              </a>
            </el-menu-item>
            <el-menu-item index="/recent-dynamic">
              <a @click="jumpPage('2')">
                <i>{{ getTitle('header.recentDynamic') }}</i>
              </a>
            </el-menu-item>
            <el-menu-item index="/news">
              <a @click="jumpPage('3')">
                <i>{{ getTitle('header.news') }}</i>
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="/interaction">
            <template slot="title"
              ><i>{{ getTitle('header.interaction') }}</i></template
            >
            <el-menu-item index="/strategy/video">
              <router-link to="/strategy/video"
                ><i>{{ getTitle('header.video') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/map">
              <router-link to="/map"
                ><i>{{ getTitle('header.explain') }}</i></router-link
              >
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="">
            <a
              href="https://www.720yun.com/t/b6vkOmfyO2y#scene_id=56970256"
              target="_blank"
              ><i>{{ getTitle('header.VR') }}</i></a
            >
          </el-menu-item>
          <el-submenu index="/booking">
            <template slot="title">
              <i>{{ getTitle('header.booking') }}</i>
            </template>
            <el-menu-item index="/ticket">
              <router-link to="/ticket"
                ><i>{{ getTitle('header.ticket') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/booking/hotel">
              <router-link to="/booking/hotel"
                ><i>{{ getTitle('header.hotel') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/booking/restaurant">
              <router-link to="/booking/restaurant"
                ><i>{{ getTitle('header.restaurant') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/booking/mall">
              <router-link to="/booking/mall"
                ><i>{{ getTitle('header.mall') }}</i></router-link
              >
            </el-menu-item>
            <el-menu-item index="/booking/guide">
              <router-link to="/booking/guide"
                ><i>{{ getTitle('header.guide') }}</i></router-link
              >
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="right-menu">
          <div class="lang-option" @click="optionsVisible = !optionsVisible">
            <!-- <span
              class="locale-img"
              :style="{ backgroundPosition: '0 ' + nowLocale.position + 'px' }"
            ></span> -->
            {{ nowLocale.display }}
            <ul v-show="optionsVisible">
              <li
                v-for="(locale, index) in avaiableLocales"
                :key="index"
                @click="localeToPath(locale.name)"
              >
                <span
                  class="locale-img"
                  :style="{ backgroundPosition: '0 ' + locale.position + 'px' }"
                ></span>
                {{ locale.display }}
              </li>
            </ul>
          </div>
          <div class="login-phone" v-if="isLogin">
            <span>
              <router-link to="/account/ticket-order">
                {{ loginPhone }}
              </router-link>
            </span>
          </div>
          <div class="login-button" @click="loginOrOut">
            {{ isLogin ? getTitle('header.logout') : getTitle('header.login') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import routerTo from '@/router/routerTo';
import { mapMutations, mapState } from 'vuex';
import user from '@/setup/user';
export default {
  data() {
    return {
      optionsVisible: false,
      phone: '',
      userNow: null,
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
      loginPhone: (state) => state.loginPhone,
    }),
    avaiableLocales() {
      return process.env.avaiableLocales;
    },
    locale() {
      return this.$store.state.locale;
    },
    nowLocale() {
      return this.avaiableLocales.find((l) => l.name === this.$i18n.locale);
    },
    // isLogin() {
    //   return localStorage.getItem('isLogin'); //this.$store.getters.isLogin;
    // },
  },
  mounted() {},
  created() {
    // 触发指定默认语言
    this.$store.commit('setLocale', this.$i18n.locale);
  },
  methods: {
    ...mapMutations(['setIsLogin', 'setLoginPhone']),
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    localeToPath(lang) {
      // console.log('click ===> ', lang);
      // console.log('nowLocale ===> ', this.nowLocale);
      if (this.nowLocale.name !== lang) {
        this.$store.commit('setLocale', lang);
        setLocaleToPath(lang);
      }
    },
    jumpPage(category) {
      // console.log('category: ', category);
      this.$store.commit('setCategory', category);
      this.$router.replace({ path: '/news', query: { category: category } });
    },
    loginOrOut() {
      if (this.isLogin) {
        localStorage.removeItem('userSession');
        this.$store.commit('delecteContact', null); //移除保存的游客信息
        this.setIsLogin(false);
        this.setLoginPhone('');
        routerTo.toLogin(this.$router, false);
      } else {
        localStorage.removeItem('userSession');
        // localStorage.removeItem('isLogin');
        this.setIsLogin(false);
        this.setLoginPhone('');
        routerTo.toLogin(this.$router, false);
      }
    },
    handleSelect(key, keyPath) {
      /*if (key === '/') {
        this.$router.push('/');
      } else if (key === '/overview/introduction') {
        this.$router.push('/overview/introduction');
      } else if (key === '/overview/tourist-attraction') {
        this.$router.push('/overview/tourist-attraction');
      } else if (key === '/strategy/traffic') {
        this.$router.push('/strategy/traffic');
      } else if (key === '/strategy/tourist-routes') {
        this.$router.push('/strategy/tourist-routes');
      } else if (key === '/strategy/photo') {
        this.$router.push('/strategy/photo');
      } else if (key === '/strategy/travel-notes') {
        this.$router.push('/strategy/travel-notes');
      } else if (key === '/dynamic/notice') {
        this.$router.push('/dynamic/notice');
      } else if (key === '/dynamic/recent-dynamic') {
        this.$router.push('/dynamic/recent-dynamic');
      } else if (key === '/dynamic/news') {
        this.$router.push('/dynamic/news');
      } else if (key === '/interaction/video') {
        this.$router.push('/interaction/video');
      } else if (key === '/guide') {
        this.$router.push('/guide');
      } else if (key === '/vr') {
        this.$router.push('/vr');
      } else if (key === '/ticket') {
        this.$router.push('/ticket');
      } else if (key === '/booking/hotel') {
        this.$router.push('/booking/hotel');
      } else if (key === '/booking/restaurant') {
        this.$router.push('/booking/restaurant');
      } else if (key === '/booking/mall') {
        this.$router.push('/booking/mall');
      } else if (key === '/booking/cicerone') {
        this.$router.push('/booking/cicerone');
      }
      console.log(key, keyPath);*/
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header-height {
  height: 70px;
}
.header-fixed {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
}
.header {
  height: 70px;
  position: relative;
  z-index: 99;
  line-height: 70px;
  vertical-align: middle;
  background: #fff;
}
.logo {
  width: 213px;
  height: 50px;
  position: absolute;
  top: 10px;
  left: 40px;
}
.menu {
  position: absolute;
  top: 0;
  left: 300px;
  list-style: none;
  li {
    float: left;
    position: relative;
    a {
      display: block;
      padding: 0 20px;
      color: #191b26;
      font-weight: bold;
      font-size: 16px;
      i {
        font-style: normal;
      }
    }
    a:hover {
      color: #31a775;
    }
    /*a.router-link-exact-active,*/
    a.router-link-active {
      width: 100%;
      background: #31a775;
      content: '';
      transform: skewX(-10deg);
      i {
        display: block;
        color: #fff;
        font-style: normal;
        transform: skewX(10deg);
      }
      &::after {
        width: 10px;
        height: 6px;
        position: absolute;
        bottom: -6px;
        left: 50%;
        background: url(../assets/images/menu-li-active.png) no-repeat;
        content: '';
        transform: skewX(10deg) translateX(-50%);
      }
    }
  }
}
.right-menu {
  display: flex;
  position: absolute;
  top: 0;
  right: 40px;
}
.lang-option {
  padding: 0 20px 0 20px;
  position: relative;
  border: none 0;
  white-space: nowrap;
  background: url(../assets/images/menu-li-active.png) no-repeat right center;
  cursor: pointer;
  outline: none 0;
  .locale-img {
    display: block;
    width: 30px;
    height: 20px;
    position: absolute;
    top: 50%;
    left: 6px;
    // background-image: url(../assets/images/lang.png);
    // background-repeat: no-repeat;
    transform: translateY(-50%);
  }
  ul {
    position: absolute;
    top: 60px;
    left: 0;
    z-index: 30;
    border-radius: 4px;
    background: #fff;
    box-shadow: 1px 1px 4px rgba(102, 102, 102, 0.2);
    li {
      height: 40px;
      padding: 0 20px 0 20px;
      position: relative;
      line-height: 40px;
      list-style: none;
      &:hover {
        border-radius: 4px;
        color: #fff;
        background-color: #31a775;
      }
    }
  }
}
.login-phone {
  margin-left: 20px;
  a {
    color: #31a775;
  }
}
.login-button {
  height: 32px;
  margin: 19px 0 19px 20px;
  padding: 0 26px;
  border: 1px solid #eee;
  border-radius: 16px;
  color: #191b26;
  line-height: 30px;
  cursor: pointer;
}
.el-menu {
  // position: relative;
  position: absolute;
  left: 290px;
  border-bottom: none !important;
  .el-menu-item {
    height: 70px;
    padding: 0 15px;
    border-bottom: none;
    line-height: 70px;
    a {
      color: #191b26;
      i {
        color: #191b26;
        font-weight: bold;
        font-size: 16px;
        font-style: normal;
      }
      :hover {
        color: #31a775;
      }
    }
  }
  .el-menu-item:hover {
    background-color: transparent !important;
  }
  .is-active {
    border-bottom: none !important;
    background: #31a775;
    transition: 0s;
    content: '';
    // transform: skewX(-10deg);
    i {
      color: #fff !important;
      font-style: normal;
      transition: 0s;
      // transform: skewX(10deg);
    }
  }
  .is-active:hover {
    background-color: #31a775 !important;
    i {
      color: #fff;
    }
  }
  .el-submenu {
    /deep/ .el-submenu__title {
      height: 70px;
      border-bottom: none;
      line-height: 70px;
      i {
        color: #191b26;
        font-weight: bold;
        font-size: 16px;
        font-style: normal;
      }
      :hover {
        color: #31a775;
      }
    }
    /deep/ .el-submenu__title:hover {
      background-color: transparent !important;
    }
    /deep/ .el-submenu__icon-arrow {
      display: none;
    }
  }
  /deep/ .el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }
}
</style>
